const API_BASE = 'https://www.dreamchimney.com/api';
const SITE_BASE = 'https://www.dreamchimney.com';

export const API_ENDPOINTS = {
    // Tracks
    tracks: {
        recent: `${API_BASE}/tracks/recent/tracks`,
        mostRecent: `${API_BASE}/tracks/most_recent`,
        popularLastWeek: `${API_BASE}/tracks/popular/last-week`,
    },

    // Activity
    activity: {
        recent: (count = 20) => `${API_BASE}/activity/recent/${count}`,
        featuredToday: `${API_BASE}/activity/recent/featured/today`,
    },

    // Message Board / Banners
    messageBoard: {
        motw: `${API_BASE}/tracks/message-board/banner/motw`,
        promoTracks: (tracks = 6) => `${API_BASE}/tracks/message-board/banner/promotracks?tracks=${tracks}`,
    },

    // Content
    quotes: {
        latest: `${API_BASE}/quotes/latest`,
    },

    question: {
        latest: `${API_BASE}/question/latest`,
    },

    // Home
    home: {
        random: `${API_BASE}/home/random`,
    },

    // Mix of the Week
    motw: {
        latest: `${API_BASE}/motw/latest`,
    },

    // Interviews
    interviews: {
        json: (cacheBuster = null) => {
            const url = `${SITE_BASE}/interviews/interviews.json`;
            return cacheBuster ? `${url}?cb=${cacheBuster}` : url;
        },
    },
};

